import axios from "axios";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { putStorage } from "hooks/useStorage";

const TripsAPI = {
    getAllTrips: async () => {
        try {
            const { data: response } = await axios.get("/trips");
            putStorage("trips", response || []);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ko50dnhc1i"));
        }
    },

    createTrip: async (data: any) => {
        try {
            const { data: response } = await axios.post("/trips", { ...data });
            await TripsAPI.getAllTrips();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("q0q5kh2jc3"));
        }
    },

    updateTrip: async (data: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = await axios.put("/trips", { ...data });
            await TripsAPI.getAllTrips();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("vmmgbc45mlk"));
        }
    },

    deleteTrip: async (id: string) => {
        try {
            const { data: response } = await axios.delete(`/trips/${id}`);
            await TripsAPI.getAllTrips();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("873rga3gye5"));
        }
    }
};

export default TripsAPI;
